import {
  getDifficultyLevelString,
  getLocalStorage,
  Loader,
  pxToRem,
  pxTovW,
  QuantityButtonV2,
  theme,
  Slide,
  deserify,
  ModeOfConductionDropdown,
  useFeatureEnabled,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import {
  Checkbox,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, display } from '@mui/system';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  BloomLevelEnum,
  DifficultyLevelEnum,
  Question_QuestionEnum,
} from '@protos/content_management/content.db_pb';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../../../../reduxStore/reduxHooks';
import { useDispatch } from 'react-redux';
import {
  IFAASSESSMENTCONFIG,
  setAssessmentCreationType,
} from '../../../reducer/assessmentFlow.slice';
import { useGlobalContext } from '../../../../../app/Context/GlobalContextProvider';

import {
  getAllQuestionTypeTitleAndEnumArray,
  getDifficultyLevelFromString,
  JEE_MARKING_SCHEME_ALLOWED_TYPES,
  markingSchemeOptions,
  OMR_CONDUCTION_MODE_ALLOWED_TYPES,
} from '../../../Common/ReviewAssessment/functions';
import {
  MarkingSchemeEnum,
  ModeOfConductionEnum,
} from '@protos/learning_management/lms.db_pb';
import {
  AssessmentCreationEnum,
  QuestionStatsListV2,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { useLocation } from 'react-router-dom';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';
import { MarkingSchemeTooltip } from 'libs/shared-ui/src/components/composites/MarkingSchemeTooltip';
import { getAvailableCountForQuestionType } from '../../../utils/QPGv2.utils';
import { getModeOfConductionEnum } from 'apps/teacher/src/utils/functions';
import { Feature } from '@protos/school_management/school.db_pb';
import {
  BLOOM_LEVEL_ARRAY,
  getMaxNoOfQuestionsLimit,
  MAXIMUM_MARKS_LIMIT,
  OMR_MAX_QUESTIONS,
} from '../../../utils/assessment.utils';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { setToastInfo } from '../../../../Auth/reducer/auth.slice';
import { getQuestionEnumArrayFromQuestionTypes } from '../../../../Homework/ReviewHomework/functions';

interface IProps {
  assessmentConfig: IFAASSESSMENTCONFIG;
  setAssessmentConfig: (config: IFAASSESSMENTCONFIG) => void;
  modeOfConduction: string;
  onChangeModeOfConduction: (value: string) => void;
}
interface SliderLevel {
  key: DifficultyLevelEnum;
  value: number;
  label?: string;
}
export const Settings = (props: IProps) => {
  const {
    assessmentConfig,
    setAssessmentConfig,
    modeOfConduction,
    onChangeModeOfConduction,
  } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const teacher_id = getLocalStorage('userId');
  const { isIpadOnly } = useGlobalContext();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { user_info } = useAppSelector((state) => state.auth);
  const { LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler } =
    useCommonServiceClientContext();
  const {
    assesment_creation_type,
    fa_assessment_config,
    fa_selected_chapter_data,
  } = deserify(useAppSelector((state) => state.assessment));

  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const handleModeOfConductionChange = (value: string) => {
    onChangeModeOfConduction(value);
    const modeEnum = getModeOfConductionEnum(value);
    if (modeEnum === ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR) {
      setAssessmentConfig({
        ...assessmentConfig,
        QuestionTypes: (assessmentConfig.QuestionTypes || []).filter((type) =>
          OMR_CONDUCTION_MODE_ALLOWED_TYPES.includes(type)
        ),
        noOfQuestions: Math.min(
          assessmentConfig.noOfQuestions,
          OMR_MAX_QUESTIONS
        ),
      });
    }
  };

  const [loading, setLoading] = useState<'loading' | 'completed'>('completed');
  const [availableConfig, setAvailableConfig] = useState<IFAASSESSMENTCONFIG>({
    noOfQuestions: assessmentConfig?.noOfQuestions || 0,
    // approximateTime: assessmentConfig?.approximateTime || 0,
    overallDifficultyLevel:
      assessmentConfig?.overallDifficultyLevel || 'Medium',
    bloomLevels: assessmentConfig?.bloomLevels || [],
    QuestionTypes: assessmentConfig?.QuestionTypes || [],
  });

  const sliderLevels = [
    { key: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW, value: 0, label: 'Easy' },
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM,
      value: 50,
      label: 'Medium',
    },
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH,
      value: 100,
      label: 'Hard',
    },
  ];

  const [sliderValue, setSliderValue] = useState<SliderLevel>({
    key: getDifficultyLevelFromString(assessmentConfig?.overallDifficultyLevel),
    value:
      sliderLevels.find(
        (e) =>
          e.key ===
          getDifficultyLevelFromString(assessmentConfig?.overallDifficultyLevel)
      )?.value || 0,
    label: assessmentConfig?.overallDifficultyLevel,
  });

  // --------------------------------------------------------------

  const isBloomLevelAvailableInConfig = (typeKey: BloomLevelEnum) =>
    availableConfig?.bloomLevels?.includes(typeKey) ?? false;

  // --------------------------------------------------------------

  const isQuestionTypeSelectable = (typeKey: Question_QuestionEnum) => {
    if (
      assesment_creation_type?.markingScheme ===
        MarkingSchemeEnum.MARKING_SCHEME_JEE &&
      !JEE_MARKING_SCHEME_ALLOWED_TYPES.includes(typeKey)
    ) {
      return false;
    }
    return isQuestionTypeAvailableInConfig(typeKey);
  };

  const questionTypeArray = useMemo(
    () => getAllQuestionTypeTitleAndEnumArray(),
    []
  );

  // --------------------------------------------------------------

  const isQuestionTypeAvailableInConfig = (typeKey: Question_QuestionEnum) =>
    getAvailableCountForQuestionType({
      questionType: typeKey,
      noOfQuestionsByTypes: availableConfig?.questionTypeCount,
    }) > 0;

  // --------------------------------------------------------------

  const filteredQuestionTypeArray =
    getAllQuestionTypeTitleAndEnumArray().filter((questionType) => {
      const isAvailableInConfig = isQuestionTypeAvailableInConfig(
        questionType.typeKey
      );
      // 1. OMR ALWAYS TAKES PRECEDENCE
      if (
        assesment_creation_type?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
      ) {
        return (
          OMR_CONDUCTION_MODE_ALLOWED_TYPES.includes(questionType.typeKey) &&
          isAvailableInConfig
        );
      }
      // 2. JEE (only if NOT OMR)
      if (
        assesment_creation_type?.markingScheme ===
        MarkingSchemeEnum.MARKING_SCHEME_JEE
      ) {
        return (
          JEE_MARKING_SCHEME_ALLOWED_TYPES.includes(questionType.typeKey) &&
          isAvailableInConfig
        );
      }

      // 3. default
      return isAvailableInConfig;
    });

  // --------------------------------------------------------------

  const maxQuantityFromSelectedTypes = useMemo(() => {
    const selectedTypes = assessmentConfig?.QuestionTypes ?? [];
    const typeCount = availableConfig?.questionTypeCount;
    if (selectedTypes.length === 0 || !typeCount) return 0;
    const totalAvailable = selectedTypes.reduce(
      (sum, questionType) =>
        sum +
        getAvailableCountForQuestionType({
          questionType,
          noOfQuestionsByTypes: typeCount,
        }),
      0
    );
    return getMaxNoOfQuestionsLimit({
      totalAvailableFromTypes: totalAvailable,
      modeOfConduction: getModeOfConductionEnum(modeOfConduction),
    });
  }, [
    assessmentConfig?.QuestionTypes,
    availableConfig?.questionTypeCount,
    modeOfConduction,
  ]);

  // --------------------------------------------------------------

  useEffect(() => {
    const currentNo = assessmentConfig?.noOfQuestions ?? 0;
    const selectedTypes = assessmentConfig?.QuestionTypes ?? [];
    const typeCount = availableConfig?.questionTypeCount;

    if (typeCount && selectedTypes.length === 0 && currentNo > 0) {
      setAssessmentConfig({
        ...assessmentConfig,
        noOfQuestions: 0,
      });
      return;
    }

    if (
      maxQuantityFromSelectedTypes > 0 &&
      currentNo > maxQuantityFromSelectedTypes
    ) {
      setAssessmentConfig({
        ...assessmentConfig,
        noOfQuestions: maxQuantityFromSelectedTypes,
      });
    }
  }, [
    maxQuantityFromSelectedTypes,
    assessmentConfig?.noOfQuestions,
    assessmentConfig?.QuestionTypes,
    availableConfig?.questionTypeCount,
  ]);

  // --------------------------------------------------------------
  const getModeIcon = (value?: string) => {
    if (!value) return 'mobile-app';
    const modeEnum = getModeOfConductionEnum(value);

    switch (modeEnum) {
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER:
        return 'clicker_icon';
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR:
        return 'omr';
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP:
      default:
        return 'mobile-app';
    }
  };
  const ALL_MODES = [
    {
      name: 'Geneo App',
      id: ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP,
    },
    {
      name: 'Geneo Clicker',
      id: ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER,
    },
    {
      name: 'OMR Test',
      id: ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR,
    },
  ];
  const featureInfo = user_info?.schoolDetails[0]?.featuresPlanInfo;
  const isOMREnabled = useFeatureEnabled(featureInfo, Feature.OMR_ENABLED);

  const isModeSupported = (mode: ModeOfConductionEnum) => {
    switch (mode) {
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER:
        return class_subject_info?.isClickerSupported;
      case ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR:
        return isOMREnabled;
      default:
        return true; // App always supported
    }
  };
  const modeOptions = ALL_MODES.filter((m) => isModeSupported(m.id));

  useEffect(() => {
    const typeCount = availableConfig?.questionTypeCount;
    if (!typeCount) return;

    const selectedTypes = assessmentConfig?.QuestionTypes ?? [];
    const filteredTypes = filterSelectableQuestionTypes(
      selectedTypes,
      typeCount,
      assesment_creation_type?.markingScheme
    );

    if (filteredTypes.length !== selectedTypes.length) {
      setAssessmentConfig({
        ...assessmentConfig,
        QuestionTypes: filteredTypes,
      });
    }
  }, [
    availableConfig?.questionTypeCount,
    assesment_creation_type?.markingScheme,
  ]);

  // --------------------------------------------------------------

  const fetchModuleQuestionStatsInitial = async (props: {
    updatedBlooms?: BloomLevelEnum[];
    preserveQuestionTypes?: boolean;
    markingScheme?: MarkingSchemeEnum;
    questionTypesToPreserve?: Question_QuestionEnum[];
  }) => {
    const {
      updatedBlooms,
      preserveQuestionTypes,
      markingScheme: markingSchemeOverride,
      questionTypesToPreserve,
    } = props;
    const moduleIds = fa_selected_chapter_data?.chapters.flatMap((chapter) => [
      chapter.chapterId,
      ...chapter.topics.map((topic) => topic.topicId),
    ]);
    if (!moduleIds || moduleIds.length === 0 || !teacher_id) {
      return;
    }

    const markingScheme =
      markingSchemeOverride ?? assesment_creation_type?.markingScheme;

    const selectedBloomLevels =
      markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
        ? undefined
        : updatedBlooms ??
          (assessmentConfig?.bloomLevels?.length
            ? assessmentConfig.bloomLevels
            : fa_assessment_config?.bloomLevels?.length
            ? fa_assessment_config.bloomLevels
            : undefined);

    const allBloomLevels = BLOOM_LEVEL_ARRAY.map(({ typeKey }) => typeKey);

    const needsUnfilteredBloomList =
      markingScheme !== MarkingSchemeEnum.MARKING_SCHEME_JEE &&
      updatedBlooms === undefined &&
      !!selectedBloomLevels?.length;

    const baseRequest = {
      personId: BigInt(teacher_id),
      personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
      modeOfConduction: getModeOfConductionEnum(modeOfConduction),
      moduleIds,
      assessmentCreationType:
        AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE,
    };

    try {
      setLoading('loading');
      let data: QuestionStatsListV2;
      let bloomLevelsForAvailable: BloomLevelEnum[] | undefined;

      if (needsUnfilteredBloomList) {
        // when the user has already visited Settings once

        const [unfilteredResponse, filteredResponse] = await Promise.all([
          // to get all the available bloom levels for the selected Chapters
          LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getModuleQuestionStats(
            { ...baseRequest, bloomLevels: allBloomLevels }
          ),

          // to get the data based on the bloom levels selected
          LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getModuleQuestionStats(
            {
              ...baseRequest,
              bloomLevels: selectedBloomLevels || allBloomLevels,
            }
          ),
        ]);
        if (!filteredResponse.data) {
          dispatch(
            setToastInfo({
              label: 'Error while fetching question stats',
              variant: 'error',
              open: true,
            })
          );
          return;
        }
        data = filteredResponse.data;
        bloomLevelsForAvailable = unfilteredResponse.data?.bloomLevels;
      } else {
        // when the user has not visited Settings once

        const response =
          await LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getModuleQuestionStats(
            {
              ...baseRequest,
              bloomLevels:
                markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
                  ? undefined
                  : selectedBloomLevels || allBloomLevels,
            }
          );
        if (!response.data) {
          dispatch(
            setToastInfo({
              label: 'Error while fetching question stats',
              variant: 'error',
              open: true,
            })
          );
          return;
        }
        data = response.data;
      }

      if (data) {
        setAvailableConfig((prev) => ({
          ...prev,
          noOfQuestions: data.noOfQuestions,
          // approximateTime: data.approximateTime || 10,
          overallDifficultyLevel: getDifficultyLevelString(
            data.avgDifficultyLevel
          ),
          bloomLevels:
            markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? []
              : updatedBlooms
              ? prev.bloomLevels
              : needsUnfilteredBloomList
              ? bloomLevelsForAvailable ?? data.bloomLevels
              : data.bloomLevels,
          QuestionTypes: data.questionTypes
            ? getQuestionEnumArrayFromQuestionTypes(data.questionTypes)
            : [],
          questionTypeCount: data.questionTypes,
        }));

        if (updatedBlooms !== undefined || preserveQuestionTypes) {
          const typesToFilter =
            questionTypesToPreserve ?? assessmentConfig?.QuestionTypes ?? [];
          const filteredQuestionTypes =
            assesment_creation_type?.modeOfConduction ===
            ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
              ? OMR_CONDUCTION_MODE_ALLOWED_TYPES
              : markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? getAvailableJeeQuestionTypes(data.questionTypes, typesToFilter)
              : filterSelectableQuestionTypes(
                  typesToFilter,
                  data.questionTypes,
                  markingScheme
                );
          setAssessmentConfig({
            ...assessmentConfig,
            noOfQuestions: Math.min(
              assessmentConfig?.noOfQuestions ?? 10,
              data.noOfQuestions
            ),
            bloomLevels:
              markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
                ? []
                : updatedBlooms ??
                  (assessmentConfig.bloomLevels?.length
                    ? assessmentConfig.bloomLevels
                    : data.bloomLevels),
            QuestionTypes: filteredQuestionTypes,
          });
        } else if (!fa_assessment_config) {
          setAssessmentConfig({
            noOfQuestions: data.noOfQuestions >= 10 ? 10 : data.noOfQuestions,
            // approximateTime: data.approximateTime || 10,
            overallDifficultyLevel: getDifficultyLevelString(
              data.avgDifficultyLevel
            ),
            bloomLevels:
              markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
                ? []
                : data.bloomLevels,
            QuestionTypes:
              assesment_creation_type?.modeOfConduction ===
              ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                ? OMR_CONDUCTION_MODE_ALLOWED_TYPES
                : markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
                ? getAvailableJeeQuestionTypes(data.questionTypes)
                : data.questionTypes
                ? getQuestionEnumArrayFromQuestionTypes(data.questionTypes)
                : [],
          });
        } else {
          const typesToFilter =
            markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? fa_assessment_config?.QuestionTypes ??
                JEE_MARKING_SCHEME_ALLOWED_TYPES
              : fa_assessment_config?.QuestionTypes ?? [];
          const filteredQuestionTypes =
            assesment_creation_type?.modeOfConduction ===
            ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
              ? OMR_CONDUCTION_MODE_ALLOWED_TYPES
              : markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? getAvailableJeeQuestionTypes(data.questionTypes, typesToFilter)
              : filterSelectableQuestionTypes(
                  typesToFilter,
                  data.questionTypes,
                  markingScheme
                );
          setAssessmentConfig({
            ...fa_assessment_config,
            bloomLevels:
              markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE
                ? []
                : fa_assessment_config.bloomLevels,
            QuestionTypes: filteredQuestionTypes,
          });
        }
      }
    } catch (err) {
      console.log(err);
      dispatch(
        setToastInfo({
          label: 'Error while fetching question stats',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading('completed');
    }
  };

  // --------------------------------------------------------------

  useEffect(() => {
    fetchModuleQuestionStatsInitial({});
  }, [modeOfConduction]);

  // --------------------------------------------------------------

  return (
    <Box
      sx={{
        width: { xs: '100%', md: pxTovW(1250), lg: pxTovW(874) },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: pxTovW(20),
      }}
    >
      {loading === 'loading' && (
        <Loader
          sx={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh' }}
        />
      )}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          marginY: { xs: pxToRem(23), md: pxTovW(41) },
        }}
      >
        <Typography variant="h2">
          <span style={{ color: '#007CDC' }}>Step 2: </span>Now Set Your
          Configuration Settings
        </Typography>
      </Box>
      {/* {class_subject_info?.isClickerSupported ? ( */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(20), md: pxTovW(20) },
        }}
      >
        <Typography variant="h3" fontWeight="bold">
          Conduction Via
        </Typography>
        <ModeOfConductionDropdown
          isEditing={true}
          iconName={getModeIcon(modeOfConduction)}
          value={modeOfConduction}
          onChange={handleModeOfConductionChange}
          optionsList={modeOptions}
        />
      </Box>
      {/* ) : (
        <></>
      )} */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          height: { md: pxTovW(120) },
          //   backgroundColor: 'red',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginY: { xs: pxToRem(20), md: pxTovW(40), lg: pxTovW(20) },
          gap: { xs: pxToRem(20), md: pxTovW(0) },
        }}
      >
        <Box
          sx={{
            width: { xs: '50%', md: '100%' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: { xs: pxToRem(10), md: pxTovW(20) },
            marginBottom: 'auto',
            // alignItems: { md: 'center' },
            marginRight: { xs: 'auto', md: 0 },
          }}
        >
          <Typography variant="h3" fontWeight="bold" marginRight={'auto'}>
            No. of Questions
          </Typography>
          <QuantityButtonV2
            value={assessmentConfig.noOfQuestions || 0}
            max={maxQuantityFromSelectedTypes}
            disabled={maxQuantityFromSelectedTypes === 0}
            onChange={(nextValue: number) => {
              setAssessmentConfig({
                ...assessmentConfig,
                noOfQuestions: nextValue,
              });
            }}
            onIncrement={async () => {
              setAssessmentConfig({
                ...assessmentConfig,
                noOfQuestions: assessmentConfig.noOfQuestions + 1,
              });
              await interactionEvent({
                url: 'Teacher_formative_assessment_create',
                context: 'Number_of_questions',
                name: 'ADD',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
            onDecrement={async () => {
              setAssessmentConfig({
                ...assessmentConfig,
                noOfQuestions: assessmentConfig.noOfQuestions - 1,
              });
              await interactionEvent({
                url: 'Teacher_formative_assessment_create',
                context: 'Number_of_questions',
                name: 'REMOVE',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
          />
        </Box>
        {/* {!isMobile && (
          <Divider
            orientation="vertical"
            sx={{
              borderColor: '1px solid red',
              width: '1px',
              height: '100%',
              marginRight: pxToRem(50),
              borderStyle: 'dashed',
            }}
          />
        )} */}

        {/* <ApproximateTime
          approximateTime={assessmentConfig.approximateTime}
          questionCount={assessmentConfig.noOfQuestions}
          difficulty={assessmentConfig.overallDifficultyLevel} // fix this
          setApproximateTime={async (time: number) => {
            setAssessmentConfig({
              ...assessmentConfig,
              approximateTime: time,
            });
            await interactionEvent({
              url: 'Teacher_formative_assessment_create',
              context: 'Approximate_time',
              name: 'TIME_SELECTION',
              pathSegments: pathSegments,
              isOffline: isOffline,
            });
          }}
        /> */}
      </Box>
      <Divider
        sx={{
          borderColor: '1px solid red',
          width: '100%',
          height: '1px',
          marginY: { xs: pxToRem(20), md: pxTovW(30) },
        }}
      />
      <Box sx={{ width: '100%', marginY: { xs: pxToRem(20), md: 0 } }}>
        <Slide
          sliderLevels={sliderLevels}
          titleText="Overall Difficulty"
          isDisable={false}
          minLevel={0}
          maxLevel={100}
          step={50}
          slideValue={sliderValue}
          SliderOnChangeValue={async (val: SliderLevel) => {
            setSliderValue(val);
            setAssessmentConfig({
              ...assessmentConfig,
              overallDifficultyLevel: val.label || 'Medium',
            });
            await interactionEvent({
              url: 'Teacher_formative_assessment_create',
              context: 'Overall_difficulty',
              name:
                val.value === DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW
                  ? 'LOW'
                  : val.value === DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM
                  ? 'MEDIUM'
                  : 'HIGH',
              pathSegments: pathSegments,
              isOffline: isOffline,
            });
          }}
        />
      </Box>
      {/*  Temporarily hiding marking scheme for clicker assessments */}
      {assesment_creation_type.modeOfConduction !==
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER && (
        <>
          {' '}
          <Divider
            sx={{
              borderColor: '1px solid red',
              width: '100%',
              height: '1px',
              marginY: { xs: pxToRem(20), md: pxTovW(30) },
              // marginTop: pxTovW(30),
            }}
          />
          <Box
            sx={{
              boxSizing: 'border-box',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
              mb: { xs: pxToRem(10), md: pxTovW(10) },
              // marginY: { xs: pxToRem(20), md: pxTovW(20) },
              marginBottom: { xs: pxToRem(30), md: pxTovW(30) },
            }}
          >
            <Typography variant="h3" fontWeight="bold">
              Marking Scheme
            </Typography>
            <Grid
              container
              spacing={2}
              columns={16}
              rowGap={5}
              sx={{
                padding: 0,
                width: '100%',
                gap: { xx: pxToRem(0), md: pxTovW(20) },
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
              }}
            >
              {markingSchemeOptions.map((marking, index) => (
                <Grid
                  item
                  xs={6}
                  md={4}
                  key={index}
                  sx={{
                    // width: { xs: '200px', md: '250px' },
                    display: 'flex',
                    height: { xs: '30px', md: '25px' },
                    // display: 'flex',
                    gap: { xs: pxToRem(8), md: pxTovW(10) },
                    alignItems: 'center',
                    paddingY: pxTovW(10),
                  }}
                >
                  <Checkbox
                    checked={
                      assesment_creation_type.markingScheme === marking.type
                    }
                    onChange={async (e) => {
                      const updatedAssessmentCreationType = {
                        ...assesment_creation_type,
                        markingScheme: marking.type,
                      };
                      if (
                        marking.type ===
                          MarkingSchemeEnum.MARKING_SCHEME_CUSTOM &&
                        e.target.checked
                      ) {
                        updatedAssessmentCreationType.marksPerQuestion =
                          assesment_creation_type.marksPerQuestion || 1;
                      }
                      // Switching away from custom marking
                      if (
                        marking.type !==
                          MarkingSchemeEnum.MARKING_SCHEME_CUSTOM &&
                        e.target.checked
                      ) {
                        updatedAssessmentCreationType.marksPerQuestion =
                          undefined;
                      }
                      dispatch(
                        setAssessmentCreationType(updatedAssessmentCreationType)
                      );

                      const questionTypesForScheme =
                        assesment_creation_type.modeOfConduction ===
                        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                          ? OMR_CONDUCTION_MODE_ALLOWED_TYPES
                          : marking.type ===
                            MarkingSchemeEnum.MARKING_SCHEME_JEE
                          ? JEE_MARKING_SCHEME_ALLOWED_TYPES
                          : assessmentConfig.QuestionTypes ?? [];

                      setAssessmentConfig({
                        ...assessmentConfig,
                        bloomLevels:
                          marking.type === MarkingSchemeEnum.MARKING_SCHEME_JEE
                            ? []
                            : assessmentConfig.bloomLevels,
                        QuestionTypes: questionTypesForScheme,
                      });

                      fetchModuleQuestionStatsInitial({
                        preserveQuestionTypes: true,
                        markingScheme: marking.type,
                        questionTypesToPreserve: questionTypesForScheme,
                      });

                      await interactionEvent({
                        url: 'Teacher_formative_assessment_create',
                        context: 'Marking_Scheme',
                        name: `${marking.title}_${
                          e.target.checked ? 'SELECT' : 'DESELECT'
                        }`
                          .toUpperCase()
                          .replace(/\s+/g, '_'),
                        pathSegments: pathSegments,
                        isOffline: isOffline,
                      });
                    }}
                    sx={{
                      height: {
                        xs: pxToRem(17),
                        md: pxTovW(30),
                        lg: pxTovW(24),
                      },
                      padding: { xs: pxToRem(5), md: pxTovW(8), lg: pxTovW(5) },
                      width: {
                        xs: pxToRem(17),
                        md: pxTovW(30),
                        lg: pxTovW(24),
                      },
                      borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
                    }}
                    color="primary"
                  />
                  <Typography
                    variant={isIpadOnly ? 'h3' : 'h4'}
                    sx={{
                      width: 'max-content',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {marking.title}
                    <span>
                      {marking.type ===
                        MarkingSchemeEnum.MARKING_SCHEME_JEE && (
                        <MarkingSchemeTooltip />
                      )}
                    </span>
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}
      <Box
        sx={{
          width: { xs: '100%', lg: '45%' },
          alignSelf: 'flex-end',
        }}
      >
        {assesment_creation_type.markingScheme ===
          MarkingSchemeEnum.MARKING_SCHEME_CUSTOM && (
          <Box sx={{ mt: 1, marginRight: 'auto' }}>
            <QuantityButtonV2
              value={assesment_creation_type.marksPerQuestion || 1}
              max={MAXIMUM_MARKS_LIMIT}
              onChange={(nextValue: number) => {
                dispatch(
                  setAssessmentCreationType({
                    ...assesment_creation_type,
                    marksPerQuestion: nextValue,
                  })
                );
              }}
              onIncrement={() => {
                dispatch(
                  setAssessmentCreationType({
                    ...assesment_creation_type,
                    marksPerQuestion: Math.min(
                      (assesment_creation_type.marksPerQuestion || 1) + 1,
                      MAXIMUM_MARKS_LIMIT
                    ),
                  })
                );
              }}
              onDecrement={() => {
                dispatch(
                  setAssessmentCreationType({
                    ...assesment_creation_type,
                    marksPerQuestion: Math.max(
                      (assesment_creation_type.marksPerQuestion || 1) - 1,
                      1
                    ),
                  })
                );
              }}
            />
          </Box>
        )}
      </Box>
      {assesment_creation_type.markingScheme !==
        MarkingSchemeEnum.MARKING_SCHEME_JEE && (
        <>
          <Divider
            sx={{
              borderColor: '1px solid red',
              width: '100%',
              height: '1px',
              marginY: { xs: pxToRem(20), md: pxTovW(30) },
              // marginTop: pxTovW(30),
            }}
          />
          <Box
            sx={{
              boxSizing: 'border-box',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
              mb: { xs: pxToRem(10), md: pxTovW(10) },
              // marginY: { xs: pxToRem(20), md: pxTovW(20) },
              marginBottom: { xs: pxToRem(30), md: pxTovW(30) },
            }}
          >
            <Typography variant="h3" fontWeight="bold">
              Bloom Level
            </Typography>
            <Grid
              container
              spacing={2}
              columns={16}
              rowGap={5}
              sx={{ padding: 0, width: '100%' }}
            >
              {BLOOM_LEVEL_ARRAY.map((bloomLevel, index) => {
                const isBloomLevelAvailable = isBloomLevelAvailableInConfig(
                  bloomLevel.typeKey
                );
                return (
                  <Grid
                    item
                    xs={6}
                    md={5}
                    lg={4}
                    key={index}
                    sx={{
                      // width: { xs: '200px', md: '250px' },
                      height: { xs: '30px', md: '25px' },
                      display: 'flex',
                      gap: { xs: pxToRem(8), md: pxTovW(10) },
                      alignItems: 'center',
                      paddingY: pxTovW(10),
                    }}
                  >
                    <Checkbox
                      disabled={!isBloomLevelAvailable}
                      checked={
                        !!assessmentConfig.bloomLevels?.find(
                          (e) => e === bloomLevel.typeKey
                        )
                      }
                      onChange={async (e) => {
                        let updatedBlooms;
                        if (e.target.checked) {
                          updatedBlooms = [
                            ...(assessmentConfig.bloomLevels || []),
                            bloomLevel.typeKey,
                          ];
                          setAssessmentConfig({
                            ...assessmentConfig,
                            bloomLevels: updatedBlooms,
                          });
                        } else {
                          updatedBlooms = (
                            assessmentConfig.bloomLevels || []
                          ).filter((level) => level !== bloomLevel.typeKey);
                          setAssessmentConfig({
                            ...assessmentConfig,
                            bloomLevels: updatedBlooms,
                          });
                        }
                        fetchModuleQuestionStatsInitial({ updatedBlooms });
                        await interactionEvent({
                          url: 'Teacher_formative_assessment_create',
                          context: 'Bloom_level',
                          name: `${bloomLevel.title}_${
                            e.target.checked ? 'SELECT' : 'DESELECT'
                          }`
                            .toUpperCase()
                            .replace(/\s+/g, '_'),
                          pathSegments: pathSegments,
                          isOffline: isOffline,
                        });
                      }}
                      sx={{
                        height: {
                          xs: pxToRem(17),
                          md: pxTovW(30),
                          lg: pxTovW(24),
                        },
                        padding: {
                          xs: pxToRem(5),
                          md: pxTovW(8),
                          lg: pxTovW(5),
                        },
                        width: {
                          xs: pxToRem(17),
                          md: pxTovW(30),
                          lg: pxTovW(24),
                        },
                        borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
                        marginX: { xs: pxToRem(5), md: pxTovW(15) },
                      }}
                      color="primary"
                    />
                    <Typography
                      variant={isIpadOnly ? 'h3' : 'h4'}
                      sx={{
                        width: 'max-content',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: isBloomLevelAvailable
                          ? 'inherit'
                          : 'text.disabled',
                      }}
                    >
                      {bloomLevel.title}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </>
      )}
      <Divider
        sx={{
          borderColor: '1px solid red',
          width: '100%',
          height: '1px',
          marginY: { xs: pxToRem(20), md: pxTovW(30) },
        }}
      />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(20), md: pxTovW(20) },
          marginY: { xs: pxToRem(20), md: pxTovW(20) },
        }}
      >
        <Typography variant="h3" fontWeight="bold">
          Question Type
        </Typography>
        <Grid
          container
          spacing={2}
          rowGap={5}
          columns={16}
          sx={{
            padding: 0,
            width: '100%',
          }}
        >
          {questionTypeArray.map((questionType, index) => {
            const isQuestionTypeEnabled = isQuestionTypeSelectable(
              questionType.typeKey
            );
            return (
              <Grid
                item
                xs={6}
                md={5}
                lg={4}
                key={index}
                sx={{
                  // width: { xs: '200px', md: '250px' },
                  height: { xs: '30px', md: '25px' },
                  display: 'flex',
                  gap: pxTovW(10),
                  alignItems: 'center',
                  paddingY: pxTovW(10),
                }}
              >
                <Checkbox
                  disabled={!isQuestionTypeEnabled}
                  checked={
                    isQuestionTypeEnabled &&
                    !!assessmentConfig.QuestionTypes?.find(
                      (e) => e === questionType.typeKey
                    )
                  }
                  onChange={async (e) => {
                    if (e.target.checked) {
                      setAssessmentConfig({
                        ...assessmentConfig,
                        QuestionTypes: [
                          ...(assessmentConfig.QuestionTypes || []),
                          questionType.typeKey,
                        ],
                      });
                    } else {
                      setAssessmentConfig({
                        ...assessmentConfig,
                        QuestionTypes: (
                          assessmentConfig.QuestionTypes || []
                        ).filter((type) => type !== questionType.typeKey),
                      });
                    }
                    await interactionEvent({
                      url: 'Teacher_formative_assessment_create',
                      context: 'Question_type',
                      name: `${questionType.title}_${
                        e.target.checked ? 'SELECT' : 'DESELECT'
                      }`
                        .toUpperCase()
                        .replace(/\s+/g, '_')
                        .replace(/[/]/g, '_'),
                      pathSegments: pathSegments,
                      isOffline: isOffline,
                    });
                  }}
                  sx={{
                    height: { xs: pxToRem(17), md: pxTovW(24) },
                    padding: { xs: pxToRem(5), md: pxTovW(5) },
                    width: { xs: pxToRem(17), md: pxTovW(24) },
                    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
                    marginX: { xs: pxToRem(5), md: pxTovW(15) },
                  }}
                  color="primary"
                />
                <Typography
                  variant={isIpadOnly ? 'h3' : 'h4'}
                  sx={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: isQuestionTypeEnabled ? 'inherit' : 'text.disabled',
                  }}
                >
                  {questionType.title}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

// ======================================================

interface IApproximateTimeProps {
  approximateTime: number;
  questionCount: number;
  difficulty: string;
  setApproximateTime: (time: number) => void;
}
export const ApproximateTime = (props: IApproximateTimeProps) => {
  const { fa_assessment_config } = useAppSelector((state) => state.assessment);
  const { approximateTime, questionCount, difficulty, setApproximateTime } =
    props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const difficultyTimes = {
    Easy: [0.5, 0.75, 1], // in minutes
    Medium: [1, 1.75, 2.5],
    Hard: [2.5, 3.25, 4],
  };

  const times = difficultyTimes[difficulty as keyof typeof difficultyTimes] || [
    1, 1.75, 2.5,
  ];

  const [selectedTime, setSelectedTime] = useState(times[1]);
  if (!times) {
    throw new Error(
      "Invalid difficulty level. Choose 'easy', 'medium', or 'hard'."
    );
  }
  useEffect(() => {
    setSelectedTime(times[1]);
  }, [difficulty]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: { xs: pxToRem(10), md: pxTovW(15) },
        marginTop: { md: pxTovW(20), lg: 0 },
      }}
    >
      <Typography variant="h3" fontWeight="bold">
        Approximate Time
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: { md: pxTovW(33) },
        }}
      >
        {times.map((time, index) => (
          <Box
            sx={{
              background: selectedTime === time ? '#007CDC' : '#F5FAFF',
              display: 'flex',
              height: { xs: pxToRem(50), md: pxTovW(75) },
              borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
              boxSizing: 'border-box',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              border: selectedTime === time ? 'none' : '2px solid #A8D3FC',
              padding: {
                xs: `${pxToRem(17)} ${pxToRem(19)}`,
                md: `${pxTovW(30)} ${pxTovW(25)}`,
                lg: `${pxTovW(28)} ${pxTovW(25)}`,
              },
              gap: { xs: pxToRem(5), md: pxTovW(5) },
            }}
            onClick={() => {
              setSelectedTime(time);
              setApproximateTime(Math.round(questionCount * time));
            }}
          >
            <AccessTimeIcon
              sx={{
                height: { xs: pxToRem(14), md: pxTovW(18) },
                width: { xs: pxToRem(14), md: pxTovW(18) },
                color: selectedTime === time ? '#FFFFFF' : 'black',
              }}
            />
            <Typography
              variant="h5"
              sx={{
                color: selectedTime === time ? '#FFFFFF' : 'black',
              }}
            >
              <Typography
                variant={isMobile ? 'h4' : 'h3'}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px', // space between number and "mins"
                  color: selectedTime === time ? '#FFFFFF' : 'black',
                }}
              >
                {Math.round(questionCount * time)}
                <Box component="span" sx={{ fontSize: 'inherit' }}>
                  mins
                </Box>
              </Typography>
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

// ======================================================

const filterSelectableQuestionTypes = (
  selectedTypes: Question_QuestionEnum[],
  questionTypeCount: IFAASSESSMENTCONFIG['questionTypeCount'],
  markingScheme: MarkingSchemeEnum | undefined
): Question_QuestionEnum[] => {
  if (!questionTypeCount) return [];
  const isJEE = markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE;
  return selectedTypes.filter((typeKey) => {
    if (isJEE && !JEE_MARKING_SCHEME_ALLOWED_TYPES.includes(typeKey)) {
      return false;
    }
    return (
      getAvailableCountForQuestionType({
        questionType: typeKey,
        noOfQuestionsByTypes: questionTypeCount,
      }) > 0
    );
  });
};

const getAvailableJeeQuestionTypes = (
  questionTypeCount: IFAASSESSMENTCONFIG['questionTypeCount'],
  selectedTypes: Question_QuestionEnum[] = JEE_MARKING_SCHEME_ALLOWED_TYPES
): Question_QuestionEnum[] =>
  filterSelectableQuestionTypes(
    selectedTypes,
    questionTypeCount,
    MarkingSchemeEnum.MARKING_SCHEME_JEE
  );
